//泰语
export default {
	voteAction: 'โหวต',
	videoNavLabel: 'วิดีโอ',
	vipLevelLabel: 'ระดับ VIP',
	betOptions: { rose: 'กุหลาบ', lily: 'ลิลลี่', fireworks: 'ดอกไม้ไฟ', balloon: 'ลูกโป่ง' },
	Language: 'ไทย',
	registerPasswordLength: 'รหัสผ่านต้องมีความยาว 6 ถึง 12 ตัวอักษร',
    system: {
        homePage: {
            title1: 'หัวข้อ 1',
            title2: 'หัวข้อ 2',
            description1: '7 วันที่ผ่านมา',
            description2: '6 เดือนที่ผ่านมา',
        }
    },
    login: {
        subtitle: 'เริ่มต้นการพบกันสุดพิเศษของคุณคืนนี้',
        register: 'ลงทะเบียนสมาชิก',
        usernamePls: 'กรุณาใส่ชื่อผู้ใช้',
        passwordPls: 'กรุณาใส่รหัสผ่าน',
        toRegister: 'ยังไม่มีบัญชี? ลงทะเบียนตอนนี้',
        doLogin: 'เข้าสู่ระบบ',
    },
    register: {
        repasswordPls: 'กรุณาใส่รหัสผ่านถอนเงิน',
        codePls: 'กรุณาใส่รหัสเชิญ',
        register: 'ลงทะเบียน',
        xieyi: 'ยอมรับข้อกำหนดการใช้งาน',
        xieyiPls: 'กรุณาเลือกข้อตกลงการเปิดบัญชีด้านล่าง!',
    },
    mine: {
        xyfs: 'คะแนนเครดิต',
        ljjf: 'คะแนนสะสม',
        recharge: 'เติมเงิน',
        withdraw: 'ถอนเงิน',
        money: 'ยอดเงินคงเหลือ',
        infomation: 'ข้อมูลพื้นฐาน',
        moneylog: 'บันทึกคะแนน',
        withdrawrecord: 'รายละเอียดการถอน',
        gamerecord: 'บันทึกของขวัญ',
        notice: 'ประกาศ',
        mymove: 'ประวัติการดู',
        loginpwd: 'รหัสผ่านเข้าสู่ระบบ',
        paypwd: 'รหัสผ่านใช้งาน',
        loginout: 'ออกจากระบบ',
        paypwdhasseted: 'ตั้งรหัสผ่านถอนเงินแล้ว หากต้องการเปลี่ยน กรุณาติดต่อฝ่ายบริการลูกค้า',
        setbank: 'กรุณาตั้งค่าบัตรรับเงิน!',
        lorr: 'เข้าสู่ระบบ/ลงทะเบียน',
    },
    infomation: {
        username: 'ไอดีสมาชิก',
        name: 'ชื่อ',
        bankcard: 'บัญชีถอนเงิน',
        phone: 'หมายเลขโทรศัพท์',
        recharge: 'เติมเงิน',
        amount: 'คะแนนที่มี',
        toserve: 'กรุณาติดต่อบริการลูกค้า',
        kfms: 'สำหรับการเติมเงินออฟไลน์ กรุณาปรึกษาฝ่ายบริการลูกค้า จำนวนเงินเติมผ่านช่องทางการชำระเงินบางช่องทางจะถูกเติมแบบสุ่มถึงทศนิยม 1 ตำแหน่ง กรุณาตรวจสอบให้แน่ใจเมื่อชำระเงิน',
    },
    withdraw: {
        title: 'ถอนเงิน',
        log: 'บันทึกการถอน',
        method: 'วิธีการถอน',
        avmoney: 'ยอดเงินที่ถอนได้',
        limit: 'ขีดจำกัดการถอน',
        submit: 'คำขอการถอนเงิน',
        xiane: 'จำกัดต่อครั้ง',
        numbers: 'จำนวนครั้งที่ถอน',
        time: 'เวลาที่ได้รับเงิน',
        zuidi: 'ต่ำสุด',
        zuigao: 'สูงสุด',
        numsmax: 'ถอนเงินสดสูงสุดต่อวัน',
        ci: 'ครั้ง',
        timedetail: 'เวลาโอนเงินทั่วไปประมาณ 5 นาที เร็วที่สุดภายใน 2 นาที',
        bank: 'บัตรธนาคาร',
        status1: 'รอตรวจสอบ',
        status2: 'สำเร็จ',
        status3: 'ล้มเหลว',
        enterCorrectAmount: 'กรุณากรอกจำนวนเงินที่ถูกต้อง',
        selectBankCard: 'กรุณาเลือกบัตรธนาคารสำหรับถอนเงิน',
        enterPayPassword: 'กรุณาใส่รหัสผ่านการชำระเงิน',
    },
    moneylog: {
        title: 'รายละเอียดเงิน',
        type1: 'การเปลี่ยนแปลง',
        type2: 'โบนัส',
        type3: 'ภารกิจ',
        type4: 'รางวัล',
        type5: 'ถอนเงิน',
        type6: 'ถอนเงินล้มเหลว',
        rechargeNote: '(เติมเงิน)',
    },
    setting: {
        loginpwdtitle: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
        oldpwd: 'กรุณาใส่รหัสผ่านเก่า',
        newpwd: 'กรุณาใส่รหัสผ่านใหม่',
        renewpwd: 'กรุณาใส่รหัสผ่านใหม่อีกครั้ง',
        change: 'เปลี่ยน',
        plseall: 'กรุณากรอกแบบฟอร์มให้ครบถ้วน!',
        pswwrong: 'รหัสผ่านที่ป้อนไม่ตรงกัน',
        paypwdtitle: 'ตั้งรหัสผ่านเงิน',
        paypwd: 'กรุณาใส่รหัสผ่านเงิน',
        repaypwd: 'กรุณาใส่รหัสผ่านเงินอีกครั้ง',
        title: 'การตั้งค่า',
        basicInfo: 'การตั้งค่าข้อมูลพื้นฐาน',
        loginPassword: 'รหัสผ่านเข้าสู่ระบบ',
        fundPassword: 'รหัสผ่านเงิน',
        logout: 'ออกจากระบบ',
        payPasswordSet: 'ตั้งรหัสผ่านถอนเงินแล้ว ต้องการเปลี่ยนกรุณาติดต่อบริการลูกค้า',
        payPasswordNotSet: 'ยังไม่ได้ตั้งค่า',
        payPasswordHasSet: 'ตั้งค่าแล้ว',
        confirm: 'ยืนยัน',
    },
    home: {
        gonggao: 'สัมผัสประสบการณ์ความหรูหราสุดพิเศษ',
        qgkf: 'เป็นไปได้ทั่วประเทศ',
        hotlist: 'รายการแนะนำยอดนิยม',
        hotgame: 'แนะนำภารกิจ',
        gaoji: 'ขั้นสูง',
        smrz: 'ยืนยันตัวตนในสถานที่',
        videorz: 'ยืนยันตัวตนด้วยวิดีโอ',
        star: 'เรตติ้ง',
        sg: 'ส่วนสูง',
        xw: 'หน้าอก',
        diqu: 'พื้นที่ให้บริการ',
        apply: 'สมัครนัดหมาย',
        ssxz: 'สถานะเรียลไทม์',
        joinvip: 'เข้าร่วมสมาชิก',
    },
    video: {
        latest: 'ล่าสุด',
        title: 'คลังวิดีโอ',
        nums: 'จำนวนการเล่น',
        bofangliang: 'จำนวนการเล่น',
        hotlist: 'แนะนำยอดนิยม',
        plsrefisrt: 'กรุณาเติมเงินเพื่อดูวิดีโอ!',
        trialEnded: 'การทดลองดูจบแล้ว',
        rechargeToWatch: 'กรุณาเติมเงินเพื่อดูฟรี',
        goRecharge: 'เติมเงินทันที',
    },
    choose: {
        title: 'คืนที่ดีที่สุด',
        nav: 'เลือกนางสนม',
        apply: 'สมัครจับคู่',
        jianjie: 'แนะนำสาวสวย',
        move: 'สามารถเคลื่อนย้ายได้',
        click: 'คลิกเพื่อยืนยัน',
        detail: 'รายละเอียด',
        videodetail: 'วิดีโอเรียลไทม์',
    },
    common: {
        refresh: 'รีเฟรชสำเร็จ',
        noallow: 'ฟังก์ชันถูกปิดใช้งาน!',
        disable: 'ปิดใช้งาน',
        all: 'ทั้งหมด',
        nomore: 'ไม่มีอีกแล้ว',
        nodata: 'ไม่มีข้อมูล',
        submit: 'ส่ง',
        more: 'ดูเพิ่มเติม',
        pinglunnav: 'ความคิดเห็น',
        pingluntitle: 'ความคิดเห็น',
        pldtitle: 'รายละเอียดความคิดเห็น',
        minenav: 'บัญชี',
        homenav: 'หน้าแรก',
        addbank: 'เพิ่มบัตรรับเงิน',
        setbank: 'บัญชีถอนเงิน',
    },
    game: {
        expect: 'หมายเลขงวด',
        jieguo: 'ข้อมูล',
        da: 'ใหญ่',
        xiao: 'เล็ก',
        dan: 'คี่',
        shuang: 'คู่',
        大: 'ใหญ่',
        小: 'เล็ก',
        单: 'คี่',
        双: 'คู่',
        order: 'คำสั่งภารกิจ',
        clear: 'ล้างคำสั่ง',
        submit: 'ยืนยันการส่ง',
        rewardSuccess: 'ส่งของขวัญสำเร็จ',
        kjcc: 'ออกรางวัลสำเร็จ หมายเลขงวด:',
        lxgly: 'กรุณาติดต่อผู้จัดการของคุณ',
        plsmoney: 'กรุณากรอกจำนวนเงิน!',
        plsnum: 'กรุณาเลือกหมายเลข!',
        moneynote: 'ยอดเงินไม่เพียงพอ กรุณาติดต่อบริการลูกค้าเพื่อเติมเงิน!',
        lefttime: 'เวลาเหลือ',
        lunci: 'หมายเลขงวด',
        workRecord: 'บันทึกภารกิจ',
        day: 'วัน',
        period: 'งวด',
        allWork: 'ภารกิจทั้งหมด',
        reset: 'รีเซ็ต',
        confirm: 'ยืนยัน',
        bonusPoints: 'คะแนนโบนัส',
        missionMoney: 'รายละเอียดจำนวนเงินภารกิจ',
        missionResult: 'ผลภารกิจ',
        points: 'คะแนน',
        workPoints: 'คะแนนภารกิจ',
        giftCompleted: 'ของขวัญเสร็จสิ้น',
        orderTime: 'เวลาสั่ง:',
        detail: 'รายละเอียด',
        content: 'เนื้อหา',
        amount: 'จำนวนเงิน',
        result: 'ผลลัพธ์',
        time: 'เวลา',
        win: 'ชนะ',
        missionFailed: 'ภารกิจล้มเหลว',
    },
    kefu: {
        title: 'บริการลูกค้าออนไลน์',
        lianxi: 'ติดต่อ',
        content: 'บริการ 24 ชั่วโมงตลอด 7 วัน',
        defaultName: 'บริการลูกค้าออนไลน์',
    },
    setname: {
        title: 'แก้ไขชื่อจริง',
        xingming: 'ชื่อ',
        tips: 'เพื่อความปลอดภัยของบัญชีคุณ ชื่อจริงต้องตรงกับชื่อบนบัตรธนาคารที่เชื่อมโยง',
        xmpls: 'กรุณาใส่ชื่อจริง',
        save: 'บันทึก',
        notreset: 'ห้ามตั้งค่าซ้ำ!',
        plsentername: 'กรุณาใส่ชื่อ!',
    },
    withdrawCenter: 'ศูนย์ถอนเงิน',
    withdrawRecord: 'บันทึกการถอน',
    withdrawAmount: 'จำนวนเงินที่ถอน',
    allMoney: 'ทั้งหมด',
    singleLimit: 'จำกัดต่อครั้ง',
    lowest: 'ต่ำที่สุด',
    highest: 'สูงที่สุด',
    withdrawTimes: 'จำนวนครั้งที่ถอน',
    maxDailyWithdraw: 'ถอนสูงสุดต่อวัน',
    times: 'ครั้ง',
    arrivalTime: 'เวลาที่ได้รับเงิน',
    limitDescription: 'คำอธิบายขีดจำกัด',
    balance: 'ยอดคงเหลือ',
    withdrawNow: 'ถอนเงินทันที',
    enterCorrectAmount: 'กรุณากรอกจำนวนเงินที่ถูกต้อง',
    personalReport: 'รายงานส่วนบุคคล',
    profitAmount: 'จำนวนกำไร',
    profitFormula: 'สูตรคำนวณกำไร: จำนวนเงินที่ชนะ - จำนวนเงินภารกิจ',
    taskAmount: 'จำนวนเงินภารกิจ',
    accountOffline: 'บัญชีออฟไลน์',
    loginRegister: 'เข้าสู่ระบบ/ลงทะเบียน',
    loginForMore: 'เข้าสู่ระบบเพื่อรับบริการเพิ่มเติม!',
    author: 'ผู้เขียน:',
    notification: 'การแจ้งเตือน',
    changePhone: 'เปลี่ยนหมายเลขโทรศัพท์',
    save: 'บันทึก',
    existingPhone: 'หมายเลขโทรศัพท์ปัจจุบัน',
    newPhone: 'หมายเลขโทรศัพท์ใหม่',
    withdrawAccountRegister: 'ลงทะเบียนบัญชีถอนเงิน',
    selectBankCard: 'กรุณาเลือกบัตรธนาคาร',
    accountNumber: 'หมายเลขบัญชี',
    enterBankCardNumber: 'กรุณาใส่หมายเลขบัตรธนาคาร',
    systemNotice: 'การแจ้งเตือนระบบ',
    myMovie: 'ภาพยนตร์ของฉัน',
    completeTaskForMore: 'ทำงานให้เสร็จเพื่อรับตั๋วหนังเพิ่ม',
    movieTicket: 'ตั๋วหนัง:',
    watchList: 'รายการดู',
    noDataYet: 'ยังไม่มีข้อมูล',
    setNameFirst: 'กรุณาตั้งชื่อก่อนเชื่อมโยงบัญชีถอนเงิน!',
    setPasswordFirst: 'กรุณาตั้งรหัสผ่านถอนเงินก่อนเชื่อมโยงบัตรธนาคาร!',
    accountHolder: 'เจ้าของบัญชี',
    enterRealName: 'กรุณาใส่ชื่อจริง',
    withdrawPassword: 'รหัสผ่านถอนเงิน',
    registerWithdrawPassword: 'กรุณาลงทะเบียนรหัสผ่านถอนเงิน',
    bankCard: 'บัตรธนาคาร',
    orderContentLabel: 'เนื้อหาคำสั่ง:',
    all: 'ทั้งหมด',
    bonusPointsLabel: 'คะแนนโบนัส',
    waitingResultLabel: 'รอผลลัพธ์',
    missionMoneyDetails: 'รายละเอียดจำนวนเงินภารกิจ',
    points: 'คะแนน',
    switch: 'สวิตช์',
    currentSelection: 'การเลือกปัจจุบัน:',
    quantity: 'จำนวน:',
    total: 'รวม',
    ticketAmount: 'จำนวนตั๋ว',
    availablePoints: 'คะแนนที่ใช้ได้',
    verify: 'ยืนยัน',
    possible: 'เป็นไปได้',
    thumb: 'นิ้วโป้ง',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    romanticDescription: 'บริการโรแมนติกของเราเพื่อปกป้องข้อมูลส่วนบุคคลของสมาชิก สามารถลงทะเบียนได้ผ่านบริการยืนยันตัวตนจริงหรือการแนะนำจากสมาชิกที่ยืนยันตัวตนแล้วเท่านั้น',
    person1: 'เซี่ยหยู',
    person2: 'หมินเสวี่ย',
	lishijl: 'บันทึกประวัติ',
	cryptoWithdraw:{title:'ถอนคริปโท',record:'ประวัติการถอน',assetTitle:'ถอนสินทรัพย์ดิจิทัล',assetSubtitle:'โอนไปยังกระเป๋าคริปโทอย่างปลอดภัย',selectCoin:'เลือกเหรียญ',selectNetwork:'เลือกเครือข่าย',walletAddress:'ที่อยู่กระเป๋ารับ',walletPlaceholder:'กรอกที่อยู่กระเป๋า',addressTip:'ตรวจสอบว่าที่อยู่รองรับ {network} การโอนไม่สามารถยกเลิกได้',amount:'จำนวนถอน',all:'ทั้งหมด',availableBalance:'ยอดคงเหลือ',network:'เครือข่ายถอน',fee:'ค่าธรรมเนียมโดยประมาณ',arrival:'ยอดรับโดยประมาณ',confirm:'ยืนยันการถอน',submitting:'กำลังส่ง...',safetyInfo:'ความปลอดภัยในการถอน',safetyCaption:'รหัสผ่านและการเข้ารหัสปกป้องเงินของคุณ',verification:'ยืนยันความปลอดภัย',passwordPrompt:'กรอกรหัสผ่านเพื่อยืนยัน',payPassword:'รหัสผ่านการชำระเงิน',passwordPlaceholder:'กรอกรหัสผ่าน',cancel:'ยกเลิก',rulesTitle:'คำแนะนำการถอนคริปโท',rule1:'ตรวจสอบว่ากระเป๋ารองรับเหรียญและเครือข่าย',rule2:'คำขอถอนจะผ่านการตรวจสอบความปลอดภัย',rule3:'เวลารับขึ้นอยู่กับเครือข่ายบล็อกเชน',rule4:'ธุรกรรมที่เสร็จแล้วไม่สามารถยกเลิกได้',enterAddress:'กรอกที่อยู่กระเป๋ารับ',invalidAddress:'ที่อยู่ไม่ตรงกับเครือข่าย',invalidAmount:'จำนวนต้องมากกว่าค่าธรรมเนียม',insufficientBalance:'จำนวนเกินยอดคงเหลือ',enterPassword:'กรอกรหัสผ่าน',passwordError:'รหัสผ่านไม่ถูกต้อง',success:'ส่งคำขอถอนแล้ว',failed:'ถอนเงินไม่สำเร็จ'},
	cryptoAddress:{bind:'ผูกที่อยู่',title:'ผูกที่อยู่ถอนเงิน',selectCoin:'เลือกสกุลเงิน',selectNetwork:'เลือกเครือข่าย',address:'ที่อยู่กระเป๋าเงิน',placeholder:'กรอกที่อยู่กระเป๋าเงิน',tip:'โปรดยืนยันว่ากระเป๋ารองรับสกุลเงินและเครือข่ายที่เลือก',save:'บันทึกที่อยู่',modify:'แก้ไขที่อยู่',saving:'กำลังบันทึก...',invalid:'ที่อยู่กระเป๋าเงินไม่ถูกต้อง',success:'บันทึกที่อยู่แล้ว',scanSuccess:'อ่านรหัส QR สำเร็จ',scanFail:'ไม่พบที่อยู่กระเป๋าเงินที่ถูกต้อง',verify:'ยืนยันรหัสผ่านธุรกรรม',password:'รหัสผ่านธุรกรรม',passwordPlaceholder:'กรอกรหัสผ่านธุรกรรม',confirm:'ยืนยันการแก้ไข',cancel:'ยกเลิก',passwordRequired:'กรุณากรอกรหัสผ่านธุรกรรม'},
};
